import { useMemo, useState } from "react";

import { UsePaginationOptions, UsePaginationReturn } from "../types/data-table";

export const usePagination = ({
  initialPage = 1,
  initialPageSize = 10,
}: UsePaginationOptions = {}): UsePaginationReturn => {
  const [currentPage, setCurrentPage] = useState(initialPage);
  const [pageSize, setPageSize] = useState(initialPageSize);

  const getPaginatedData = useMemo(() => {
    return <T>(data: T[]) => {
      const startIndex = (currentPage - 1) * pageSize;
      const endIndex = startIndex + pageSize;
      return data.slice(startIndex, endIndex);
    };
  }, [currentPage, pageSize]);

  const startIndex = useMemo(() => {
    return (currentPage - 1) * pageSize;
  }, [currentPage, pageSize]);

  const endIndex = useMemo(() => {
    return startIndex + pageSize;
  }, [startIndex, pageSize]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handlePageSizeChange = (size: number) => {
    setPageSize(size);
    setCurrentPage(1); // Reset to first page when page size changes
  };

  return {
    currentPage,
    pageSize,
    totalPages: 0, // This will be calculated in the consuming component
    startIndex,
    endIndex,
    setCurrentPage: handlePageChange,
    setPageSize: handlePageSizeChange,
    getPaginatedData,
  };
};
